import { useSubscribedMutation } from '@setvi/shared/hooks';
import { formatProductBody } from 'pages/auto-rfq/utils';
import { PricingMode, useRfqConfigStore } from 'pages/auto-rfq/store/rfqConfig';
import {
  AutoRFQQueryKey,
  QuotesQueryKey,
  updateAutoRfqItemsMutation
} from 'Services';

export const useUpdateItem = ({
  rfqId,
  triggerApis = [QuotesQueryKey.GET_SINGLE, QuotesQueryKey.PREVIEW_PDF]
}: {
  rfqId: string;
  triggerApis?: string[];
}) => {
  const { mutateAsync: updateRfqItems, isLoading: areItemsUpdating } =
    useSubscribedMutation(
      {
        ...updateAutoRfqItemsMutation(),
        onerror: () => {}
      },
      [
        ...triggerApis,
        AutoRFQQueryKey.GET_RFQ_ANALYTICS,
        AutoRFQQueryKey.GET_ITEMS_METADATA
      ]
    );

  const { pricing } = useRfqConfigStore();

  const handleItemUpdate = async (p: any) => {
    const matchedProduct =
      p?.matchedInternalProducts?.[p?.internalIndex || 0] || null;

    // Manual-entry items have no real sell until the client has full customer pricing
    const omitSell =
      p?.manualEntry && pricing?.mode !== PricingMode.CUSTOMER_PRICING;

    const productForUpdate = {
      ...formatProductBody({
        competitor: p,
        product: matchedProduct,
        selected: false,
        edit: true,
        fileUrl: p?.fileUrl || ''
      }),
      manualEntry: p?.manualEntry || false,
      prevItemPercentage: p?.prevItemPercentage || 0,
      statusId: p?.statusId,
      _id: p.id,
      isMatched: p?.isMatched,
      matchOverride: p?.matchOverride,
      inQuote: p?.inQuote || false,
      ...(omitSell ? {} : { sell: p?.sell || 0 }),
      ...(p?.cost !== null && p?.cost !== undefined
        ? { cost: p?.cost || 0 }
        : {})
    };

    const res = await updateRfqItems({
      rfqId,
      products: [productForUpdate]
    });

    return res;
  };

  return { handleItemUpdate, areItemsUpdating };
};
